import _ from 'lodash'
import analyzeResultUtils from '@/store/result/utils/analyzeresult'

export default {
  name: 'AnalyzeCondition',
  props: {
    analyzeTargetCode: null,
    jobId: null,
    conditions: {
      type: Object,
      default: null
    },
    condition_jp: {
      type: Object,
      default: null
    },
    showExportButton: {
      type: Boolean,
      default: true
    },
    showInDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    analyze_mode: null,
    term: {
      search_term_base: null,
      search_term_target: null,
      search_term_base_dates: null,
      search_term_target_dates: null,
      search_term_base_time: null,
      search_term_target_time: null,
      search_term_newitem: null,
      search_term_month: null
    },
    age_reference: null,
    product: {
      code_pattern: null,
      base: {
        contents: null,
        codes: null,
        freeword: null,
        codes_exclude: null
      },
      target: {
        all: null,
        contents: null,
        codes: null,
        freeword: null,
        codes_exclude: null
      }
    },
    shop: {
      base: {
        all: null,
        contents: null,
        codes: null,
        freeword: null,
        codes_exclude: null
      },
      target: {
        all: null,
        contents: null,
        codes: null,
        freeword: null,
        codes_exclude: null
      }
    },
    member: {
      mask_flag: null,
      contents: null,
      codes: null,
      genders: null,
      age_target: null,
      age_codes: null,
      decile: null,
      rank: null,
      rank_month: null,
      quantity: null,
      amount: null,
      visit: null,
      gross: null,
      card: null,
      payment: null,
      age_reference: null,
      basket_price: null,
      non_member: null,
      exclude_flag: null
    },
    other: {
      groupbys: null,
      total_displays: null,
      zero_data_flag: null
    },
    flags: {
      product_has_target: false,
      shop_has_target: false,
      has_product: true
    }
  }),
  mounted () {
  },
  methods: {
    updateAnalyzeMode () {
      if (this.analyzeTargetCode === 'IF00007' && this.condition_jp) {
        switch (this.condition_jp.type_mode) {
          case 0:
            this.analyze_mode = '期間併買'
            break
          case 1:
            this.analyze_mode = '直前期間購入者分析'
            break
          case 2:
            this.analyze_mode = '直後期間購入者分析'
            break
          default:
            this.analyze_mode = null
        }
      } else {
        this.analyze_mode = null
      }
    },
    exportItems (type, codePattern) {
      this.$emit('onExportItems', { type: type, code_pattern: codePattern })
    },
    onClose () {
      this.$emit('onConditionClose')
    },
    isMemberConditionNotEmpty (value) {
      return value && value !== '〜' && value !== 'None〜None'
    },
    initCondition () {
      this.term = {
        search_term_base: null,
        search_term_target: null,
        search_term_base_dates: null,
        search_term_target_dates: null,
        search_term_base_time: null,
        search_term_target_time: null,
        search_term_newitem: null,
        search_term_month: null
      }
      this.age_reference = null
      this.product = {
        code_pattern: null,
        base: {
          contents: null,
          codes: null,
          freeword: null,
          codes_exclude: null
        },
        target: {
          all: null,
          contents: null,
          codes: null,
          freeword: null,
          codes_exclude: null
        }
      }
      this.shop = {
        base: {
          all: null,
          contents: null,
          codes: null,
          freeword: null,
          codes_exclude: null
        },
        target: {
          all: null,
          contents: null,
          codes: null,
          freeword: null,
          codes_exclude: null
        }
      }
      this.member = {
        mask_flag: null,
        contents: null,
        codes: null,
        genders: null,
        age_target: null,
        age_codes: null,
        decile: null,
        rank: null,
        rank_month: null,
        quantity: null,
        amount: null,
        visit: null,
        gross: null,
        card: null,
        payment: null,
        age_reference: null,
        basket_price: null,
        non_member: null,
        exclude_flag: null
      }
      this.other = {
        groupbys: null,
        total_displays: null,
        zero_data_flag: null
      }
      this.flags = {
        product_has_target: false,
        shop_has_target: false,
        has_product: true
      }
    }
  },
  watch: {
    conditions (condition) {
    },
    analyzeTargetCode (code) {
      this.updateAnalyzeMode()
    },
    condition_jp (condition) {
      this.initCondition()
      this.updateAnalyzeMode()
      if (condition) {
        if (condition.age_reference) {
          this.age_reference = condition.age_reference
        } else {
          this.age_reference = null
        }

        if (condition.term) {
          let conditionTerm = condition.term
          if (conditionTerm.base_setting === 1) {
            this.term.search_term_base = conditionTerm.search_term_base.from + ' 〜 ' + conditionTerm.search_term_base.to
            if (this.term.search_term_base.indexOf('null') !== -1) {
              this.term.search_term_base = null
            }
          }
          if (conditionTerm.has_target === 1) {
            this.term.search_term_target = conditionTerm.search_term_target.from + ' 〜 ' + conditionTerm.search_term_target.to
          }
          if (conditionTerm.base_setting === 2) {
            this.term.search_term_base_dates = conditionTerm.search_term_base_box.join('\n')
          }
          if (conditionTerm.base_setting === 3) {
            this.term.search_term_base_dates = conditionTerm.search_term_base_dates.join('\n')
          }
          if (conditionTerm.has_target === 1) {
            if (conditionTerm.target_setting === 2) {
              this.term.search_term_target_dates = conditionTerm.search_term_target_box.join('\n')
            }
            if (conditionTerm.target_setting === 3) {
              this.term.search_term_target_dates = conditionTerm.search_term_target_dates.join('\n')
            }
          }
          if (conditionTerm.has_base_time === 1) {
            this.term.search_term_base_time = conditionTerm.search_term_base_time.from + ' 〜 ' + conditionTerm.search_term_base_time.to
          }
          if (conditionTerm.has_target === 1 && conditionTerm.has_target_time === 1) {
            this.term.search_term_target_time = conditionTerm.search_term_target_time.from + ' 〜 ' + conditionTerm.search_term_target_time.to
          }
          this.term.search_term_newitem = conditionTerm.search_term_newitem
          this.term.search_term_month = conditionTerm.search_term_month
        } else {
          this.term = null
        }

        if (analyzeResultUtils.analyze_without_product(this.analyzeTargetCode)) {
          this.flags.has_product = false
        } else {
          if (condition.product) {
            let conditionProduct = condition.product

            if (conditionProduct.has_target === 1) {
              this.flags.product_has_target = true
            }

            this.product.code_pattern = conditionProduct.code_pattern

            let itemBase = conditionProduct.item_base
            if (itemBase.analyze.is_all === 1) {
              this.product.base.contents = '全商品'
            } else {
              let analyzeMode = itemBase.analyze.mode
              if (analyzeMode === 'code') {
                this.product.base.contents = itemBase.analyze.code
              }
              if (analyzeMode === 'file') {
                this.product.base.contents = itemBase.analyze.file
              }
              if (analyzeMode === 'name') {
                this.product.base.contents = itemBase.analyze.name
              }
              if (analyzeMode === 'group') {
                this.product.base.contents = '商品グループから選択'
                this.product.base.codes = itemBase.analyze.group.join('\n')
              }
              if (analyzeMode === 'category') {
                this.product.base.contents = 'カテゴリーから選択'
                if (Array.isArray(itemBase.analyze.category)) {
                  this.product.base.codes = itemBase.analyze.category.join('\n')
                }
              }
              if (analyzeMode === 'category_group') {
                this.product.base.contents = 'カテゴリーグループから選択'
                if (Array.isArray(itemBase.analyze.category_group)) {
                  this.product.base.codes = itemBase.analyze.category_group.join('\n')
                }
              }
              if (analyzeMode === 'product_attribute') {
                this.product.base.contents = '商品属性から選択'
                if (Array.isArray(itemBase.analyze.product_attribute)) {
                  this.product.base.codes = itemBase.analyze.product_attribute.join('\n')
                }
              }
              // 2031: 「商品コードを利用」で分析した場合、分析条件に商品区分（首都圏／近畿圏）が表示されますが、
              // こちらはカテゴリ指定またはカテゴリグループ指定の場合のみ、表示する
              if (analyzeMode === 'category' || analyzeMode === 'category_group') {
                if (itemBase.analyze.product_area_code) {
                  this.product.base.product_area_code = itemBase.analyze.product_area_code
                }
              }
              this.product.base.freeword = itemBase.analyze.freeword
              this.product.base.codes_exclude = itemBase.analyze.code_exclude.join('\n')
            }

            if (conditionProduct.target_all_flag === 1) {
              this.product.target.all = 1
              this.product.target.contents = '対象商品全て'
            } else {
              let itemTarget = conditionProduct.item_target
              if (itemTarget.analyze.is_all === 1) {
                this.product.target.contents = '全商品'
              } else {
                let analyzeMode = itemTarget.analyze.mode
                if (analyzeMode === 'code') {
                  this.product.target.contents = itemTarget.analyze.code
                }
                if (analyzeMode === 'file') {
                  this.product.target.contents = itemTarget.analyze.file
                }
                if (analyzeMode === 'name') {
                  this.product.target.contents = itemTarget.analyze.name
                }
                if (analyzeMode === 'group') {
                  this.product.target.contents = '商品グループから選択'
                  this.product.target.codes = itemTarget.analyze.group.join('\n')
                }
                if (analyzeMode === 'category') {
                  this.product.target.contents = 'カテゴリーから選択'
                  if (Array.isArray(itemTarget.analyze.category)) {
                    this.product.target.codes = itemTarget.analyze.category.join('\n')
                  }
                }
                if (analyzeMode === 'category_group') {
                  this.product.target.contents = 'カテゴリーグループから選択'
                  if (Array.isArray(itemTarget.analyze.category_group)) {
                    this.product.target.codes = itemTarget.analyze.category_group.join('\n')
                  }
                }
                if (analyzeMode === 'product_attribute') {
                  this.product.target.contents = '商品属性から選択'
                  if (Array.isArray(itemTarget.analyze.product_attribute)) {
                    this.product.target.codes = itemTarget.analyze.product_attribute.join('\n')
                  }
                }
                // 2031: 「商品コードを利用」で分析した場合、分析条件に商品区分（首都圏／近畿圏）が表示されますが、
                // こちらはカテゴリ指定またはカテゴリグループ指定の場合のみ、表示する
                if (analyzeMode === 'category' || analyzeMode === 'category_group') {
                  if (itemTarget.analyze.product_area_code) {
                    this.product.target.product_area_code = itemTarget.analyze.product_area_code
                  }
                }
                this.product.target.freeword = itemTarget.analyze.freeword
                this.product.target.codes_exclude = itemTarget.analyze.code_exclude.join('\n')
              }
            }
          }
        }

        if (condition.shop) {
          let conditionShop = condition.shop

          if (conditionShop.has_target === 1) {
            this.flags.shop_has_target = true
          }

          let shopBase = conditionShop.shop_base
          if (shopBase) {
            if (shopBase.analyze.is_all) {
              this.shop.base.all = 1
              this.shop.base.contents = '全店舗'
            } else {
              let analyzeMode = shopBase.analyze.mode
              if (analyzeMode === 'file') {
                this.shop.base.contents = shopBase.analyze.file
              }
              if (analyzeMode === 'code') {
                this.shop.base.contents = shopBase.analyze.code
              }
              if (analyzeMode === 'name') {
                this.shop.base.contents = shopBase.analyze.name
              }
              if (analyzeMode === 'group') {
                this.shop.base.contents = '店舗グループから選択'
                this.shop.base.codes = shopBase.analyze.group.join('\n')
              }
              if (analyzeMode === 'category') {
                this.shop.base.contents = 'カテゴリーから選択'
                this.shop.base.codes = shopBase.analyze.category.join('\n')
              }
              this.shop.base.freeword = shopBase.analyze.freeword
              this.shop.base.codes_exclude = shopBase.analyze.code_exclude.join('\n')
            }
          }

          let shopTarget = conditionShop.shop_target
          if (shopTarget) {
            if (shopTarget.analyze.is_all) {
              this.shop.target.all = 1
              this.shop.target.contents = '全店舗'
            } else {
              let analyzeMode = shopTarget.analyze.mode
              if (analyzeMode === 'file') {
                this.shop.target.contents = shopTarget.analyze.file
              }
              if (analyzeMode === 'code') {
                this.shop.target.contents = shopTarget.analyze.code
              }
              if (analyzeMode === 'name') {
                this.shop.target.contents = shopTarget.analyze.name
              }
              if (analyzeMode === 'group') {
                this.shop.target.contents = '店舗グループから選択'
                this.shop.target.codes = shopTarget.analyze.group.join('\n')
              }
              if (analyzeMode === 'category') {
                this.shop.target.contents = 'カテゴリーから選択'
                this.shop.target.codes = shopTarget.analyze.category.join('\n')
              }
              this.shop.target.freeword = shopTarget.analyze.freeword
              this.shop.target.codes_exclude = shopTarget.analyze.code_exclude.join('\n')
            }
          }
        }

        if (condition.member) {
          let conditionMember = condition.member

          if (conditionMember.mask_flag) {
            this.member.mask_flag = conditionMember.mask_flag
          }
          let analyzeMode = conditionMember.mode
          if (analyzeMode === 'group') {
            this.member.contents = '会員グループから選択'
            this.member.codes = conditionMember.member_ids.analyze.group.join('\n')
          }
          if (analyzeMode === 'code') {
            this.member.contents = conditionMember.member_ids.analyze.code
          }
          if (analyzeMode === 'file') {
            this.member.contents = conditionMember.member_ids.analyze.file
          }
          if (analyzeMode === 'detail') {
            this.member.contents = '会員条件から選択'
          }
          if (conditionMember.gender && conditionMember.gender.length > 0) {
            this.member.genders = '性別：' + conditionMember.gender.join('、')
          }
          if (conditionMember.age_target) {
            this.member.age_target = '年代：' + conditionMember.age_target
          }
          if (conditionMember.age_code && conditionMember.age_code.length > 0) {
            this.member.age_codes = '年代コード：' + conditionMember.age_code.join('、')
          }
          if (this.isMemberConditionNotEmpty(conditionMember.decile)) {
            this.member.decile = 'デシル：' + conditionMember.decile
          }
          if (this.isMemberConditionNotEmpty(conditionMember.rank)) {
            this.member.rank = 'ランク：' + conditionMember.rank
          }
          if (conditionMember.rank_month) {
            this.member.rank_month = 'ランク対象月：' + conditionMember.rank_month
          }
          if (this.isMemberConditionNotEmpty(conditionMember.quantity)) {
            this.member.quantity = '買上点数：' + conditionMember.quantity
          }
          if (this.isMemberConditionNotEmpty(conditionMember.amount)) {
            this.member.amount = '買上金額：' + conditionMember.amount
          }
          if (this.isMemberConditionNotEmpty(conditionMember.visit)) {
            this.member.visit = '来店回数：' + conditionMember.visit
          }
          if (this.isMemberConditionNotEmpty(conditionMember.gross)) {
            this.member.gross = '粗利額：' + conditionMember.gross
          }
          if (conditionMember.card && conditionMember.card.length > 0) {
            this.member.card = 'カード種別：' + conditionMember.card.join('、')
          }
          if (conditionMember.payment) {
            this.member.payment = '決済区分：' + conditionMember.payment
          }
          if (conditionMember.age_reference) {
            this.member.age_reference = conditionMember.age_reference
          }
          if (this.isMemberConditionNotEmpty(conditionMember.basket_price)) {
            this.member.basket_price = 'バスケット金額：' + conditionMember.basket_price
          }
          if (conditionMember.non_member) {
            this.member.non_member = '非会員：' + conditionMember.non_member
          }
          // exclude_flag は以下2パターンの値をハンドリングする:
          // 1. 生値 "1" (即時実行の旧経路で fr-app の rebuild_condition_jp が未変換だった頃のデータ用、後方互換)
          // 2. 既に変換済みの日本語文字列 (現在は fr-app/fr-batch の rebuild_condition_jp が両方とも変換する)
          if (conditionMember.exclude_flag) {
            if (String(conditionMember.exclude_flag) === '1' && ['group', 'code', 'file'].includes(analyzeMode)) {
              this.member.exclude_flag = '分析対象から指定会員を除外する：有効'
            } else if (typeof conditionMember.exclude_flag === 'string' &&
                       conditionMember.exclude_flag !== '0' &&
                       conditionMember.exclude_flag !== '1') {
              this.member.exclude_flag = conditionMember.exclude_flag
            }
          }
        }

        if (condition.groupby) {
          let groupbys = _.filter(condition.groupby, function (groupby) {
            return !_.includes(['固定集約項目', '合計行', 'ランクID'], groupby)
          })
          this.other.groupbys = groupbys.join('\n')
        }

        if (condition.aggregate) {
          this.other.aggregates = condition.aggregate.join('\n')
        }

        if (condition.total_display) {
          let allTotalDisplay = []
          condition.total_display.forEach(function (item) {
            allTotalDisplay.push(item.display_name)
          })
          this.other.total_displays = allTotalDisplay.join('\n')
        }
        if (condition.zero_data_flag) {
          this.other.zero_data_flag = condition.zero_data_flag
        }
      }
    }
  }
}
